import React from 'react';
import { InputField } from 'vindi-ds-components';

function CustomerCityField() {
  return (
    <InputField
      placeholder='Digite aqui sua cidade'
      label='Cidade'
      name='city'
    />
  );
}

export default CustomerCityField;
